import { useContext, useEffect, useState } from 'react';
import clonedeep from 'lodash.clonedeep';
import { Card, CardHeader, CardContent, Grid, Button, CardActions, Select, MenuItem, FormControl, InputLabel, Avatar, Typography, Chip } from '@material-ui/core';
import { SearchUser } from '../../../../common';
import { RolesContext } from '../RolesContext';
import { NavContext, NavRoutes,  } from '../../../../contexts';
import { ApplicationRoles, SapTableNames, LocalTableNames, } from '../../../../../helpers';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { getTableValuesItemsCodeByDBType, getTable } from '../../../../../helpers/Utils';
import { DbType } from '../../../../../helpers/Common';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    formGroup: {
        width: '100%'
    },
    select: {
        width: '100%'
    },
    user: {
        display: 'flex',
        alignItems: 'center'
    },
    label: {
    },
    avatar: {
        marginRight: theme.spacing(1)
    },
    email: {
        marginLeft: theme.spacing(1)
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    chip: {
        margin: 2
    },
    changeButton: {
        marginLeft: theme.spacing(3)
    }
}));

export const RoleAssigmentForm = (props) => {
    const classes = useStyles();
    const { navigateTo } = useContext(NavContext);

    const {
        state,
        isAddingInRole,
        addUserInRole,
        isUpdatingInRole,
        updateUserInRole,
        getTableOptionsWithCode,
        getTableValues
    } = useContext(RolesContext);

    const getTableValuesItemsCodeFromBothDBTypes = (tableName, state) => {
        if (state.tables && state.tables.length > 0) {
            const table = getTable(tableName, state);

            let eccTable = null;

            if (tableName === SapTableNames.CustomerGroups6)
                eccTable = getTable(SapTableNames.CustomerGroups, state);

            if (table && (table.childValues_ECC || table.childValues_S4)) {
                const handledEccValues = (
                    eccTable !== null ?
                    [...eccTable.childValues_ECC] :
                    [...table.childValues_ECC]
                ).map(x => {
                    x.dbType = "ECC";
                    return x;
                });

                const handledS4Values = [ ...table.childValues_S4].map(x => {
                    x.dbType = "S4";
                    return x;
                });

                const bothDbChildValues = handledEccValues.concat(handledS4Values);

                return bothDbChildValues.map((item, index: number): JSX.Element =>
                    <MenuItem
                        key={index}
                        value={item.tableValueId}
                    >
                        {item.externalKey} - {item.value} ({item.dbType})
                    </MenuItem>
                );
            }
            else
                return [];
        }
        else
            return [];
    };

    const getTableItemValueFromBothDb = (tableName, valueId) => {
        const table = getTable(tableName, state);

        let eccTable = null;

        if (tableName === SapTableNames.CustomerGroups6)
            eccTable = getTable(SapTableNames.CustomerGroups, state);

        if (table && (table.childValues_ECC || table.childValues_S4)){
            const handledEccValues = (
                eccTable !== null ?
                [...eccTable.childValues_ECC] :
                [...table.childValues_ECC]
            ).map(x => {
                x.dbType = "ECC";
                return x;
            });

            const handledS4Values = [ ...table.childValues_S4].map(x => {
                x.dbType = "S4";
                return x;
            });

            const bothDbChildValues = handledEccValues.concat(handledS4Values);
            const item = bothDbChildValues.find(x => x.tableValueId === valueId);

            if (item)
                return item.externalKey + " - " + item.value + " (" + item.dbType + ")";
            else
                return null;
        }
        else
            return null;
    };

    const getTableItemValueFromS4 = (tableName, valueId) => {
        const table = getTable(tableName, state);

        if (table && table.childValues_S4) {
            const item = table.childValues_S4.find(x => x.tableValueId === valueId);

            if (item)
                return item.externalKey + " - " + item.value;
            else
                return null;
        }
        else
            return null;
    };

    const [userKey, setUserKey] = useState(null);
    const userChangeHandler = (user) => {
        setUserKey(user ? user.id : null);
    };

    const [salesGroupIds, setSalesGroupIds] = useState([]);
    const salesGroupSelectHandler = (e) => {
        setSalesGroupIds(e.target.value);
    };

    const [businessCategoryId, setBusinessCategoryId] = useState<any>("");
    const businessCategorySelectHandler = (e) => {
        setBusinessCategoryId(e.target.value);
    };

    const [companiesIds, setCompaniesIds] = useState([]);
    const companiesSelectHandler = (e) => {
        setCompaniesIds(e.target.value);
    };

    const [salesOrgIds, setSalesOrgIds] = useState([]);
    const salesOrgsSelectHandler = (e) => {
        setSalesOrgIds(e.target.value);
    };

    const [customerGroups6Ids, setCustomerGroups6Ids] = useState([]);
    const customerGroups6SelectHandler = (e) => {
        setCustomerGroups6Ids(e.target.value);
    };

    const [countriesIds, setCountriesIds] = useState([]);
    const countriesSelectHandler = (e) => {
        setCountriesIds(e.target.value);
    };

    const saveClickHandler = async () => {
        let values: { valueId: number; dbType: number }[] = [];

        const assignDbTypeToTableValueId = (tableName, valueIds, isS4Only = false) => {
            const table = getTable(tableName, state);

            return (
                (
                    //business category is valorized as a string by dropdown selection but it becomes an array if its state is valorized from saved data. This mess is due to the fact business category is the only dropdown not multivalue but it shares the same array based functions of all the other multivalue fields 
                    !Array.isArray(valueIds) ?
                    [valueIds] :
                    valueIds
                )
                .map(valueId => {
                    const isS4 = table.childValues_S4.some(x => x.tableValueId === valueId);
                    //const isECC = table.childValues_ECC.some(x => x.tableValueId === valueId);

                    return {
                        valueId,
                        dbType: isS4Only || isS4 ? DbType.S4 : DbType.ECC
                    };
                })
            );
        };

        switch (state.role.name) {
            case ApplicationRoles.AOFOpener:
                const salesGroupValues = assignDbTypeToTableValueId(SapTableNames.SalesGroups, salesGroupIds, true);
                const businessCategoryOpenerValue = assignDbTypeToTableValueId(LocalTableNames.BusinessCategories, businessCategoryId, true);
                const companyOpenerValues = assignDbTypeToTableValueId(SapTableNames.Companies, companiesIds);
                const salesOrganizationValues = assignDbTypeToTableValueId(SapTableNames.SalesOrganizations, salesOrgIds);

                values = values.concat(salesGroupValues, businessCategoryOpenerValue, companyOpenerValues, salesOrganizationValues);

                break;

            case ApplicationRoles.LogisticCustomerService:
                const businessCategoryLCSValue = assignDbTypeToTableValueId(LocalTableNames.BusinessCategories, businessCategoryId, true);
                const countryValues = assignDbTypeToTableValueId(SapTableNames.Countries, countriesIds);
                const customerGroup6Values = assignDbTypeToTableValueId(SapTableNames.CustomerGroups6, customerGroups6Ids);

                values = values.concat(businessCategoryLCSValue, countryValues, customerGroup6Values);

                break;

            case ApplicationRoles.AccountReceivable:
                const companyAccountReceivableValues = assignDbTypeToTableValueId(SapTableNames.Companies, companiesIds);
                values = values.concat(companyAccountReceivableValues);

                break;

            default:
                break;
        }

        let success = false;

        if (!props.editMode) {
            success = await addUserInRole({
                userKey: userKey,
                roleId: state.role.applicationRoleId,
                values
            });
        }
        else {
            success = await updateUserInRole({
                userKey: state.user.externalKey,
                roleId: state.role.applicationRoleId,
                values
            });
        }

        if (success)
            navigateTo(NavRoutes.Admin.EditRole, [state.role.applicationRoleId]);
    };

    useEffect(() => {
        if (companiesIds) {
            if (companiesIds.length === 0)
                setSalesOrgIds([])
            else {
                const salesOrgs = getTableValues(SapTableNames.SalesOrganizations, companiesIds).map(x => x.tableValueId);
                let newSalesOrgs = clonedeep(salesOrgIds);
                newSalesOrgs = newSalesOrgs.filter(id => salesOrgs.includes(id));
                setSalesOrgIds(newSalesOrgs)
            }
        }
    }, [companiesIds]);

    useEffect(() => {
        if (state.tables.length > 0 && state.role != null && state.user != null){
            const getTableValueIdsFromBothDb = (state, table, tableCgEcc = null) => {
                let valueIds_ECC = [];
                let valueIds_S4 = [];

                valueIds_ECC = state.user.values_ECC
                    .filter(value =>
                        value.tableDefinitionId === (tableCgEcc !== null ? tableCgEcc.tableDefinitionId : table.tableDefinitionId)
                    )
                    .map(value => value.tableValueId);

                valueIds_S4 = state.user.values_S4
                    .filter(value => value.tableDefinitionId === table.tableDefinitionId)
                    .map(value => value.tableValueId);

                return valueIds_ECC.concat(valueIds_S4);
            };

            const getTableValueIdsFromS4 = (state, table) => {
                let valueIds_S4 = [];

                //S4 values have not been saved yet 
                if (
                    state.user.values_S4.length === 0 &&
                    state.user.values_ECC.length > 0
                ){
                    //getting TableValueIds from ECC to S4
                    valueIds_S4 = table
                        .childValues_S4
                        .filter(s4 => {
                            const commonValueFromBothDb = state.user.values_ECC.find(ecc =>
                                ecc.externalKey === s4.externalKey &&
                                ecc.value === s4.value
                            );

                            return !!commonValueFromBothDb;
                        })
                        .map(value => value.tableValueId);
                }
                else {
                    valueIds_S4 = state.user.values_S4
                        .filter(value => value.tableDefinitionId === table.tableDefinitionId)
                        .map(value => value.tableValueId);
                }

                return valueIds_S4;
            };

            switch (state.role.name) {
                case ApplicationRoles.AOFOpener:
                    const salesGroupTable = getTable(SapTableNames.SalesGroups, state);
                    const salesGroupIds_S4 = getTableValueIdsFromS4(state, salesGroupTable);
                    setSalesGroupIds(salesGroupIds_S4);

                    const bcOpenerTable = getTable(LocalTableNames.BusinessCategories, state);
                    const bcOpenerIds_S4 = getTableValueIdsFromS4(state, bcOpenerTable);
                    setBusinessCategoryId(bcOpenerIds_S4);

                    const companiesOpenerTable = getTable(SapTableNames.Companies, state);
                    const companiesOpenerIds = getTableValueIdsFromBothDb(state, companiesOpenerTable);
                    setCompaniesIds(companiesOpenerIds);

                    const salesOrganizationsTable = getTable(SapTableNames.SalesOrganizations, state);
                    const salesOrganizationsIds = getTableValueIdsFromBothDb(state, salesOrganizationsTable);
                    setSalesOrgIds(salesOrganizationsIds);

                    break;

                case ApplicationRoles.LogisticCustomerService:
                    const customerGroups6Table = getTable(SapTableNames.CustomerGroups6, state);
                    const customerGroupsTable = getTable(SapTableNames.CustomerGroups, state);
                    const customerGroups6Ids = getTableValueIdsFromBothDb(state, customerGroups6Table, customerGroupsTable);
                    setCustomerGroups6Ids(customerGroups6Ids);

                    const countryTable = getTable(SapTableNames.Countries, state);
                    const countryTableIds_S4 = getTableValueIdsFromS4(state, countryTable);
                    setCountriesIds(countryTableIds_S4);

                    const bcLogisticCustomerServiceTable = getTable(LocalTableNames.BusinessCategories, state);
                    const bcLogisticCustomerServiceIds_S4 = getTableValueIdsFromS4(state, bcLogisticCustomerServiceTable);
                    setBusinessCategoryId(bcLogisticCustomerServiceIds_S4);

                    break;

                case ApplicationRoles.AccountReceivable:
                    const companiesAccountReceivableTable = getTable(SapTableNames.Companies, state);
                    const companiesAccountReceivableIds = getTableValueIdsFromBothDb(state, companiesAccountReceivableTable);
                    setCompaniesIds(companiesAccountReceivableIds);

                    break;

                default:
                    break;
            }
        }
    }, [state.tables, state.role, state.user]);

    const [allowSave, setAllowSave] = useState(false);
    useEffect(() => {
        if (state.role != null) {
            switch (state.role.name) {
                case ApplicationRoles.AOFOpener:
                    setAllowSave(
                        (userKey !== null || state.user) &&
                        salesGroupIds.length !== 0 &&
                        businessCategoryId !== "" &&
                        companiesIds.length !== 0 &&
                        salesOrgIds.length !== 0
                    );
                    break;

                case ApplicationRoles.LogisticCustomerService:
                    setAllowSave(
                        (userKey !== null || state.user) &&
                        businessCategoryId !== "" &&
                        customerGroups6Ids.length !== 0 &&
                        countriesIds.length !== 0
                    );
                    break;

                case ApplicationRoles.AccountReceivable:
                    setAllowSave(
                        (userKey !== null || state.user) &&
                        companiesIds.length !== 0
                    );
                    break;

                default:
                    setAllowSave(userKey !== null);
                    break;
            }
        }
    }, [state.role, state.user, userKey, salesGroupIds, businessCategoryId, customerGroups6Ids, countriesIds, companiesIds, salesOrgIds])

    const [disabled, setDisabled] = useState(false);
    useEffect(() => {
        setDisabled(isAddingInRole || isUpdatingInRole);
    }, [isAddingInRole, isUpdatingInRole]);

    return (
        <Card className={classes.root}>
            <CardHeader
                title={
                    !state.user ?
                    `Add user in the '${state.role ? state.role.groupName : "unknown"}' group` :
                    `Edit user in the '${state.role ? state.role.groupName : "unknown"}' group`
                }
            />

            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        {
                            props.editMode && state.user ?
                                <>
                                    <Typography
                                        variant="overline"
                                        className={classes.label}
                                    >
                                        Target User
                                    </Typography>

                                    <div className={classes.user}>
                                        <Avatar aria-label="recipe" className={classes.avatar}>
                                            <PersonIcon />
                                        </Avatar>
                                        <Typography>
                                            {state.user.displayName}
                                        </Typography>
                                        <Typography className={classes.email}>
                                            ({state.user.email || "no email"})
                                        </Typography>
                                    </div>
                                </> :
                                <div className={classes.formGroup}>
                                    <SearchUser
                                        isAllUsers={true}
                                        label="Target user"
                                        getOptionLabel={option => `${option.displayName} (${option.mail})`}
                                        getOptionValue={option => option.id}
                                        disabled={disabled}
                                        onChange={userChangeHandler}
                                    />
                                </div>
                        }
                    </Grid>
                    {
                        state.role &&
                        state.role.name === ApplicationRoles.AOFOpener &&
                        <>
                            <Grid item xs={12}>
                                <FormControl className={classes.formGroup}>
                                    <InputLabel id="sales-group-label">Sales Groups</InputLabel>
                                    <Select
                                        multiple
                                        disabled={disabled}
                                        className={classes.select}
                                        value={salesGroupIds}
                                        onChange={salesGroupSelectHandler}
                                        renderValue={(selected: any): JSX.Element =>
                                            <div className={classes.chips}>
                                                {
                                                    selected.map((id, index: number): JSX.Element =>
                                                        <Chip
                                                            key={index}
                                                            label={getTableItemValueFromS4(SapTableNames.SalesGroups, id)}
                                                            className={classes.chip}
                                                        />
                                                    )
                                                }
                                            </div>
                                        }
                                    >
                                        {getTableValuesItemsCodeByDBType(SapTableNames.SalesGroups, state, DbType.S4)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl className={classes.formGroup}>
                                    <InputLabel id="bc-label">Business Category</InputLabel>
                                    <Select
                                        className={classes.select}
                                        labelId="bc-label"
                                        value={businessCategoryId}
                                        disabled={disabled}
                                        onChange={businessCategorySelectHandler}
                                    >
                                        {getTableValuesItemsCodeByDBType(LocalTableNames.BusinessCategories, state, DbType.S4)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl className={classes.formGroup}>
                                    <InputLabel id="company-label">Companies</InputLabel>
                                    <Select
                                        multiple
                                        labelId="company-label"
                                        disabled={disabled}
                                        className={classes.select}
                                        value={companiesIds}
                                        onChange={companiesSelectHandler}
                                        renderValue={(selected: any): JSX.Element =>
                                            <div className={classes.chips}>
                                                {
                                                    selected.map((id, index: number): JSX.Element =>
                                                        <Chip
                                                            key={index}
                                                            label={getTableItemValueFromBothDb(SapTableNames.Companies, id)}
                                                            className={classes.chip}
                                                        />
                                                    )
                                                }
                                            </div>
                                        }
                                    >
                                        {getTableValuesItemsCodeFromBothDBTypes(SapTableNames.Companies, state)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl className={classes.formGroup}>
                                    <InputLabel id="so-label">Sales Organizations</InputLabel>
                                    <Select
                                        multiple
                                        labelId="so-label"
                                        className={classes.select}
                                        value={salesOrgIds}
                                        disabled={disabled}
                                        onChange={salesOrgsSelectHandler}
                                        renderValue={(selected: any): JSX.Element =>
                                            <div className={classes.chips}>
                                                {
                                                    selected.map((id, index: number): JSX.Element =>
                                                        <Chip
                                                            key={index}
                                                            label={getTableItemValueFromBothDb(SapTableNames.SalesOrganizations, id)}
                                                            className={classes.chip}
                                                        />
                                                    )
                                                }
                                            </div>
                                        }
                                    >
                                        {
                                            getTableOptionsWithCode(SapTableNames.SalesOrganizations, companiesIds).map((item, index: number): JSX.Element =>
                                                <MenuItem
                                                    key={index}
                                                    value={item.value}
                                                >
                                                    {item.label}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                        </>
                    }

                    {
                        state.role &&
                        state.role.name === ApplicationRoles.LogisticCustomerService &&
                        <>
                            <Grid item xs={12}>
                                <FormControl className={classes.formGroup}>
                                    <InputLabel id="bc-label">Business Category</InputLabel>
                                    <Select
                                        className={classes.select}
                                        labelId="bc-label"
                                        value={businessCategoryId}
                                        disabled={disabled}
                                        onChange={businessCategorySelectHandler}
                                    >
                                        {getTableValuesItemsCodeByDBType(LocalTableNames.BusinessCategories, state, DbType.S4)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl className={classes.formGroup}>
                                    <InputLabel id="csc-label">Customer Groups</InputLabel>
                                    <Select
                                        multiple
                                        className={classes.select}
                                        labelId="csc-label"
                                        value={customerGroups6Ids}
                                        disabled={disabled}
                                        onChange={customerGroups6SelectHandler}
                                        renderValue={(selected: any): JSX.Element =>
                                            <div className={classes.chips}>
                                                {
                                                    selected.map((id, index: number): JSX.Element =>
                                                        <Chip
                                                            key={index}
                                                            label={getTableItemValueFromBothDb(SapTableNames.CustomerGroups6, id)}
                                                            className={classes.chip}
                                                        />
                                                    )
                                                }
                                            </div>
                                        }
                                    >
                                        {getTableValuesItemsCodeFromBothDBTypes(SapTableNames.CustomerGroups6, state)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl className={classes.formGroup}>
                                    <InputLabel id="countries-label">Countries</InputLabel>
                                    <Select
                                        multiple
                                        labelId="countries-label"
                                        disabled={disabled}
                                        className={classes.select}
                                        value={countriesIds}
                                        onChange={countriesSelectHandler}
                                        renderValue={(selected: any): JSX.Element =>
                                            <div className={classes.chips}>
                                                {
                                                    selected.map((id, index: number): JSX.Element =>
                                                        <Chip
                                                            key={index}
                                                            label={getTableItemValueFromS4(SapTableNames.Countries, id)}
                                                            className={classes.chip}
                                                        />
                                                    )
                                                }
                                            </div>
                                        }
                                    >
                                        {getTableValuesItemsCodeByDBType(SapTableNames.Countries, state, DbType.S4)}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </>
                    }

                    {
                        state.role &&
                        state.role.name === ApplicationRoles.AccountReceivable &&
                        <>
                            <Grid item xs={12}>
                                <FormControl className={classes.formGroup}>
                                    <InputLabel id="company-label">Companies</InputLabel>
                                    <Select
                                        multiple
                                        labelId="company-label"
                                        disabled={disabled}
                                        className={classes.select}
                                        value={companiesIds}
                                        onChange={companiesSelectHandler}
                                        renderValue={(selected: any): JSX.Element =>
                                            <div className={classes.chips}>
                                                {
                                                    selected.map((id, index: number): JSX.Element =>
                                                        <Chip
                                                            key={index}
                                                            label={getTableItemValueFromBothDb(SapTableNames.Companies, id)}
                                                            className={classes.chip}
                                                        />
                                                    )
                                                }
                                            </div>
                                        }
                                    >
                                        {getTableValuesItemsCodeFromBothDBTypes(SapTableNames.Companies, state)}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </>
                    }
                </Grid>
            </CardContent>
            <CardActions>
                <Button
                    color="primary"
                    variant="contained"
                    disabled={!allowSave || disabled}
                    onClick={saveClickHandler}>
                    {props.editMode ? "Save Changes" : "Add User"}
                </Button>
            </CardActions>
        </Card>
    );
}